import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const burgerRef = useRef(null);

    // UX: Menü schließt bei Klick außerhalb
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuOpen &&
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                burgerRef.current &&
                !burgerRef.current.contains(event.target)
            ) {
                setMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuOpen]);

    // Menü schließt bei Klick auf Menüpunkt
    const handleMenuClick = () => setMenuOpen(false);

    return (
        <header className="page-color text-white py-3 sticky-top shadow">
            <nav className="container d-flex flex-wrap justify-content-between align-items-center position-relative">
                <div className="d-flex align-items-center gap-2">
                    <Link to="/" className="pl-3 hover-effect">
                        <img src="/img/lotusbluete_logo.jpeg" alt="Lotus Logo" height="40"/>
                    </Link>
                    <h1 className="h4 m-2">Lotusblüte</h1>
                </div>
                {/* Burger Icon nur auf Mobile */}
                <button
                    ref={burgerRef}
                    className={`burger-menu d-md-none${menuOpen ? ' open' : ''}`}
                    aria-label="Menü öffnen"
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen((open) => !open)}
                >
                    <span className="burger-bar"></span>
                    <span className="burger-bar"></span>
                    <span className="burger-bar"></span>
                </button>
                {/* Navigation */}
                <ul
                    ref={menuRef}
                    className={`nav main-nav${menuOpen ? ' open' : ''}`}
                >
                    <li className="nav-item"><a href="#about" className="nav-link text-white" onClick={handleMenuClick}>Über uns</a></li>
                    <li className="nav-item"><a href="#brochure" className="nav-link text-white" onClick={handleMenuClick}>Unser Angebot</a></li>
                    <li className="nav-item"><a href="#gallery" className="nav-link text-white" onClick={handleMenuClick}>Galerie</a></li>
                    <li className="nav-item"><a href="#cards" className="nav-link text-white" onClick={handleMenuClick}>Visitenkarten</a></li>
                    <li className="nav-item"><a href="#contact" className="nav-link text-white" onClick={handleMenuClick}>Kontakt</a></li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js